import {EmbalajeActionTypes, EmbalajeState, LOAD_EMBALAJES_SUCCESS} from "../types/embalajeActionTypes";

export default function embalajeReducer(state = [], action: EmbalajeActionTypes): EmbalajeState[]{
    switch (action.type) {
        case LOAD_EMBALAJES_SUCCESS:
            return action.embalajes;
        default:
            return state;
    }
}
